import React, {Component} from 'react';
import {Form, Input} from 'antd';
import request from 'superagent';
import NotificationManager from '../../../commons/CustomNotificationManager.js';
import AlertConfigurationServiceMsgConfirm from './AlertConfigurationServiceMsgConfirm.js';
const FormItem = Form.Item;

class AlertConfigurationServiceQueryForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saDetail: {},
            saData: {},
            isFirst: true,
            save: false
        };
    }

    componentDidMount() {
        var saDetail = this.props.saDetail;
        var saData = this.props.saData;
        this.setState({
            saDetail: saDetail,
            saData: saData,
            isFirst: true,
            save: false
        })
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.saDetail && nextProps.saDetail.index && this.state.saDetail.index !== nextProps.saDetail.index && this.state.isFirst) || this.state.save) {
            var saDetail = nextProps.saDetail;
            var saData = nextProps.saData;
            this.props.form.setFieldsValue({
                queryTitle: saDetail.queryTitle,
                queryTimerInfo: saDetail.queryTimerInfo,
                queryTimeRange: saDetail.queryTimeRange,
                searchSize: saDetail.searchSize,
                alertType: saDetail.alertType,
                alertTimeout: saDetail.alertTimeout
            });
            this.setState({
                saDetail: saDetail,
                saData: saData,
                isFirst: false,
                save: false
            })
        } else {
            this.setState({
                isFirst: true
            })
        }
    }

    //onCellChange = (key, dataIndex) => {
    //    return (value) => {
    //        const saDetail = [...this.state.saDetail];
    //        const target = saDetail.find(item => item.key === key);
    //        if (target) {
    //            target[dataIndex] = value;
    //            this.setState({saDetail});
    //        }
    //    };
    //}

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let saDetail = this.state.saDetail;
                saDetail.queryTitle = values.queryTitle;
                saDetail.queryTimerInfo = values.queryTimerInfo;
                saDetail.queryTimeRange = values.queryTimeRange;
                saDetail.searchSize = values.searchSize;
                saDetail.alertType = values.alertType;
                saDetail.alertTimeout = values.alertTimeout;
                let saData = this.state.saData;
                for (let i = 0; i < saData.length; i++) {
                    if (saData[i].index === saDetail.index) {
                        saData[i] = saDetail;
                        break;
                    }
                }
                request.post('/api/dashboard/alert/configuration/serviceSave')
                    .withCredentials()
                    .set('Content-Type', 'application/json; charset=utf-8')
                    .send({saData})
                    .end((error, response) => {
                        if (!error && response) {
                            this.props.onSuccess();
                            this.setState({save: true});
                            NotificationManager.success('Succeed to save configuration.');
                        } else {
                            NotificationManager.error('Failed to save configuration.');
                        }
                    });
            }
        });

    }

    render() {
        const {getFieldDecorator} = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 10}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 14}
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0
                },
                sm: {
                    span: 14,
                    offset: 0
                },
            },
        };

        return (
            <Form style={{maxWidth: 800}}>
                <div>
                    <FormItem {...formItemLayout} label="Query Title">
                        {getFieldDecorator('queryTitle', {})(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="Query Timer Info">
                        {getFieldDecorator('queryTimerInfo', {})(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="Query Time Range">
                        {getFieldDecorator('queryTimeRange', {})(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="Search Size">
                        {getFieldDecorator('searchSize', {})(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="Alert Type">
                        {getFieldDecorator('alertType', {})(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="Alert Timeout">
                        {getFieldDecorator('alertTimeout', {})(
                            <Input />
                        )}
                    </FormItem>
                </div>
                <div className="hr-dashed"></div>
                <FormItem {...tailFormItemLayout}>
                    {/*<Button type="primary" htmlType="submit" className="login-form-button">
                     Save
                     </Button>*/}
                    <AlertConfigurationServiceMsgConfirm handleSubmit={this.handleSubmit}/>
                </FormItem>
            </Form>
        );
    }
}
const AlertConfigurationServiceQuery = Form.create()(AlertConfigurationServiceQueryForm);
export default AlertConfigurationServiceQuery;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationServiceQuery.js